export default {
  setAffiliate(state, affiliate) {
    state.affiliate = affiliate;
  },
  setAffiliates(state, affiliates) {
    state.affiliates = affiliates;
  },
  setUnvaluedAffiliates(state, affiliates) {
    state.unvaluedAffiliates = affiliates;
  },
};
